module.exports = __webpack_public_path__ + "static/media/renBTC.611497c3.svg";